import { UploadOutlined } from "@ant-design/icons";
import { Button, Input, message, Modal, Upload } from "antd";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { saveSinistreFile } from "../../../hooks/useHooks";
import axiosInstance from "../../../variables/api/axiosInstance";

const { Dragger } = Upload

const RemiseCheque = (prop) => {
    const [modalDecaissementSinistre, setModalDecaissementSinistre] = useState(
        false
    );
    const [cheque, setCheque] = useState("");
    const [cni, setCni] = useState("");
    const [loading, setLoading] = useState(false);
    const [numeroCni, setNumeroCni] = useState("");
    const [representant, setRepresentant] = useState("");

    const handleDecaissementSubmit = async () => {
        setLoading(true);
        const decaissement = prop?.decaissement;
        if (!decaissement) {
            message.error("Erreur lors de la remise");
            setLoading(false);
            return;
        }

        if (!numeroCni || numeroCni.trim() === "") {
            message.error("Numero de CNI obligatoire");
            setLoading(false);
            return;
        }

        const remiseDTO = {
            cni: numeroCni.trim(),
            representant: representant ? representant.trim() : null,
            recepteurCodeId: prop?.recepteur?.codeId || null
            // piecesJustificatives: [ ... ] // inactif cote backend pour le moment
        };

        try {
            const res = await axiosInstance.put(
                `/api/decaissement/remise/${decaissement.codeId}`,
                JSON.stringify(remiseDTO),
                { headers: { 'Content-Type': 'application/json' } }
            );
            message.success("Remise de chèque effectuée avec succès");
            setModalDecaissementSinistre(false);
            setNumeroCni("");
            setRepresentant("");
            if (prop.onSuccess) prop.onSuccess(res.data);
            else window.location.reload();
        } catch (err) {
            console.log(err);
            const msg = err?.response?.data?.message || "Erreur lors de la remise du chèque";
            message.error(msg);
        } finally {
            setLoading(false);
        }
    };

    const uploadSinistreFile = async (file, onSuccess, onError, onProgress) => {
        try {

            const response = await saveSinistreFile(file);
            console.log(response.data)
            //  await formik.setFieldValue('croquis', sessionStorage.getItem('file'))
            message.success(`${file.name} téléversé avec succès.`);
            return response
        } catch (error) {
            // Handle errors
            onError(error);
            message.error(`Échec de l'upload du fichier: ${file.name}`);
        }
    }

    const props = {
        name: "cheque",
        customRequest: async (options) => {
            const { file, onSuccess, onError, onProgress } = options;
            const resCheque = await uploadSinistreFile(file, onSuccess, onError, onProgress)
            setCheque(resCheque);
            console.log('cni cheque ', cheque);

        },
        onChange(info) {
            if (info.file.status !== "uploading") {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === "done") {
                setCheque(info.file.originFileObj);
                toast.success(`${info.file.name} fichier téléversé avec succès`);
            } else if (info.file.status === "error") {
                toast.error(
                    `${info.file.name} erreur lors du téléversement du fichier.`
                );
            }
        },
        progress: {
            strokeColor: {
                "0%": "#108ee9",
                "100%": "#87d068",
            },
            strokeWidth: 3,
            format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
        },
    };
    const getFrenchDate = () => {
        const now = dayjs();
        return now.format("DD-MM-YYYY");
    };
    const props2 = {
        name: "cni",
        customRequest: async (options) => {
            const { file, onSuccess, onError, onProgress } = options;
            const resCni = await uploadSinistreFile(file, onSuccess, onError, onProgress)
            console.log('cni r', resCni)
            setCni(resCni)
            console.log('cni 2 ', cni)
        },
        onChange(info) {
            if (info.file.status !== "uploading") {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === "done") {
                setCni(info.file.originFileObj);
                console.log('cni ', cni)
                message.success(`${info.file.name} fichier téléversé avec succès`);
            } else if (info.file.status === "error") {
                message.error(
                    `${info.file.name} erreur lors du téléversement du fichier.`
                );
            }
        },
        progress: {
            strokeColor: {
                "0%": "#108ee9",
                "100%": "#87d068",
            },
            strokeWidth: 3,
            format: (percent) => percent && `${parseFloat(percent.toFixed(2))}%`,
        },
    };

    useEffect(() => {
        console.log(prop.decaissement);
        setModalDecaissementSinistre(prop.open);
    }, [prop.open]);

    // useEffect(() => {
    //   prop.setOpen(modalDecaissementSinistre);
    // }, [modalDecaissementSinistre]);

    return (
        <Modal
            title="Remise de chèque"
            confirmLoading={loading}
            centered
            open={modalDecaissementSinistre}
            onOk={() => handleDecaissementSubmit()}
            onCancel={prop.onCancel}
            okText={"Effectuer"}
            cancelText={"Annuler"}
            width={700}
        >
            <div className="row">

                <br />
                <div className="col-12" style={{ justifyContent: 'center', marginTop: '5%' }}>
                    <Dragger {...props}>
                        <Button icon={<UploadOutlined />}>
                            Joindre le fichier du chèque
                        </Button>
                    </Dragger>
                </div>
                <br />
                <div className="col-12" style={{ justifyContent: 'center', marginTop: '5%' }}>
                    <Dragger {...props2}>
                        <Button icon={<UploadOutlined />}>
                            Joindre la CNI endossant le chèque
                        </Button>
                    </Dragger>
                </div>
                <br />
                <div className="col-12" style={{ justifyContent: 'center', marginTop: '5%' }}>
                    <Input
                        placeholder="N° de CNI"
                        value={numeroCni}
                        onChange={(e) => setNumeroCni(e.target.value)}
                    />
                </div>
                <br />
                <div className="col-12" style={{ justifyContent: 'center', marginTop: '5%' }}>
                    <Input
                        placeholder="Nom du représentant"
                        value={representant}
                        onChange={(e) => setRepresentant(e.target.value)}
                    />
                </div>
            </div>
        </Modal>
    );
};

RemiseCheque.propTypes = {
    open: PropTypes.bool,
    // setOpen: PropTypes.func,
    decaissement: PropTypes.object,
    sinistre: PropTypes.object,
};

export default RemiseCheque;
